import type { PathParamsBase } from "@mpa/toolbox/endpoint/Endpoint";
import type RouteNavigator from "@mpa/toolbox/navigation/Navigator";
import type Route from "@mpa/toolbox/navigation/Route";

import { useLocationPathname } from "./location";

export function useIsRouteActive(route: Route | RouteNavigator) {
    const pathname = useLocationPathname();
    return route.matches(pathname);
}

export function usePathParams<PathParams extends PathParamsBase>(route: Route<PathParams>) {
    const pathname = useLocationPathname();
    if (!route.matches(pathname))
        throw new Error(`Route ${route.path} does not match path ${pathname}`);
    return route.getPathParams(pathname);
}
